const SidebarEventDefinitionDetails = (id) => ({
  id: "event-definition-details",
  title: "Event Definition Details",
  componentKey: "replay-search-sidebar",
  props: { alertId: void 0, definitionId: id }
});
export default SidebarEventDefinitionDetails;
